import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useRecoilCallback } from 'recoil';
import {
  chinaSeaFreightState,
  chinaImportState,
  multiplePhoneNumbersState,
  multipleSaveShipmentLoadingState,
  multipleShipmentCounponListState,
  multipleShipmentRatesState,
  multipleShipmentResultsState,
  saveOrderSummaryPathState,
  saveShipmentDetailsState,
  saveShopNShipRateState,
  selectedInsurancePlan,
  selectedRateState,
  shipmentDestinationSelectionState,
  shipmentHubSelectionState,
  shipmentMethodSelectionState,
  shipmentOptionSelectionState,
  shipmentRequestState,
  shopNShipDetailsState,
  shopNShipResultState,
  shopnshipSelectedCountryState,
  shopnshipSelectedProductState,
  frozenFoodsDetailsState,
  frozenFoodsFinalChargeState,
  createdFrozenFoodDataState
} from '../recoil/atoms';

export default function useClearLocalStorage() {
  const { search } = useLocation();

  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const searchParamsId = searchParams.get('lsp');

  const clearLocalData = useRecoilCallback(
    ({ reset }) => extra => {
      reset(chinaSeaFreightState);
      reset(saveShipmentDetailsState);
      reset(shopNShipDetailsState);
      reset(shopNShipResultState);
      reset(shipmentRequestState);
      reset(shipmentOptionSelectionState);
      reset(shipmentMethodSelectionState);
      reset(shipmentHubSelectionState);
      reset(chinaImportState);
      reset(selectedInsurancePlan);
      reset(selectedRateState);
      reset(shopnshipSelectedProductState);
      reset(shopnshipSelectedCountryState);
      reset(saveShopNShipRateState);
      reset(multipleSaveShipmentLoadingState);
      reset(multipleShipmentRatesState);
      reset(multipleShipmentResultsState);
      reset(saveOrderSummaryPathState);
      reset(multiplePhoneNumbersState);
      reset(shipmentDestinationSelectionState);
      reset(multipleShipmentCounponListState);
      reset(frozenFoodsDetailsState);
      reset(createdFrozenFoodDataState);
      reset(frozenFoodsFinalChargeState);

      localStorage.clear();
      if (searchParamsId) {
        localStorage.setItem('lspId', searchParamsId);
      }

      if (extra) {
        extra();
      }
    },
    [searchParamsId]
  );

  return clearLocalData;
}
